import { useMutation } from '@apollo/client';
import { NotifyDriverRewardResponse, NotifyDriverRewardRequest, CITRIN_NOTIFY_DRIVER_REFERRAL_REWARD } from '..';

type UpdateMutationFunction = (id: string) => Promise<string>;

export const useNotifyDriverReferralRewardMutation = () => {
    const [mutation, { loading }] = useMutation<NotifyDriverRewardResponse, NotifyDriverRewardRequest>(
        CITRIN_NOTIFY_DRIVER_REFERRAL_REWARD
    );

    const notifyDriverReward: UpdateMutationFunction = async (id) => {
        const result = await mutation({ variables: { id } });
        return result?.data?.CITRIN_MGT_notifyDriverReferralReward ?? '';
    };

    return { notifyDriverReward, loading };
};
